import { GridAreaSpec } from './gridSpec.types.ts';

/**
 * Builds a uniform `columns × rows` grid as a trivial area map (one unique token per
 * cell, equal weights). Lets uniform presets stay authored as `(columns, rows)` while
 * the model itself only deals in area maps.
 */
export const uniformGridSpec = (columns: number, rows: number): GridAreaSpec => {
  const lines: string[] = [];
  for (let row = 0; row < rows; row++) {
    const tokens: string[] = [];
    for (let col = 0; col < columns; col++) {
      tokens.push('r' + row + 'c' + col);
    }
    lines.push(tokens.join(' '));
  }
  return { areas: lines.join('\n') };
};
